import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../../store/useAppStore';
import { getHalfMatchSummary } from '../../../utils/orderUtils';
import { containsOutOfStock } from '../../../utils/stockUtils';
import CardHeader from './CardHeader';
import StateButtons from './StateButtons';
import InlineTimer from './InlineTimer';
import ToppingsSection from './ToppingsSection';
import SmartJoinHint from './SmartJoinHint';

function OrderCard({ order, index, count, onMove, smartJoin, halfCount, joinWith }) {
  const joinSelection = useAppStore((state) => state.joinSelection);
  const selected = joinSelection.includes(order.id);

  const joinHint =
    halfCount === 2 && joinWith
      ? [{ order: joinWith, ...getHalfMatchSummary(order, joinWith) }]
      : smartJoin;

  return (
    <div
      className={`rounded-lg border bg-[color:var(--app-surface)] shadow-sm ${
        selected
          ? 'border-emerald-500/60 ring-1 ring-emerald-500/30'
          : 'border-[color:var(--app-border)]'
      }`}
    >
      <CardHeader order={order} index={index} count={count} onMove={onMove} halfCount={halfCount} />

      <div className="space-y-3 px-4 py-3">
        {joinHint && <SmartJoinHint order={order} matches={joinHint} />}
        {order.awaitingCustomerAck && <StockAckNotice order={order} />}
        <StateButtons order={order} />
        <InlineTimer order={order} />
        <ToppingsSection order={order} />
      </div>
    </div>
  );
}

// Baker-side notice: the owning customer must still decide what to do about
// out-of-stock toppings (blocked transitions are enforced server-side too).
function StockAckNotice({ order }) {
  const { t } = useTranslation();
  const config = useAppStore((state) => state.config);
  const outOfStock = containsOutOfStock(order, config);

  return (
    <div className="rounded-md border border-amber-500/40 bg-amber-500/10 px-4 py-3">
      <p className="text-sm font-semibold theme-accent-warm">{t('stock.awaitingAck')}</p>
      {outOfStock.length > 0 && (
        <p className="mt-1 flex flex-wrap gap-x-2 text-sm theme-muted">
          {outOfStock.map((topping) => (
            <span key={topping} className="line-through opacity-70">{topping}</span>
          ))}
        </p>
      )}
    </div>
  );
}

export default OrderCard;